import React, { Component } from 'react';
export const data = [
  {
    number: 1,
    name: 'North Coast Drainage',
    type: 'polygon',
    value: '12.46 31.48 13.54 31.27 13.26 30.56 13.33 29.71 13.68 29.28 14.82 29.5 16.11 29.25 14.96 28.26 14.74 27.98 13.33 25.7 12.58 25.26 11.43 24.82 11.05 24.13 10.58 23.69 10.14 23.35 9.64 22.94 9.42 22.44 8.99 22.35 8.67 21.91 8.77 21.29 9.55 20.6 8.95 19.54 8.89 19.07 9.17 18.75 9.96 18.75 9.96 17.16 9.61 16.16 9.8 15.38 9.39 13.88 9.46 13.44 8.99 12.78 9.39 12.06 11.3 10.88 11.02 10.06 11.58 9.22 11.68 8.69 11.99 8.4 11.86 7.9 12.39 7.65 12.3 7.06 12.93 6.47 12.55 5.93 12.77 5.31 16.65 4.21 17.4 4.81 19.09 5.59 19.96 5.59 22.59 4.12 24.12 2.34 24.12 0.28 4.98 0.28 4.73 0.37 2.98 0.37 2.7 0.21 1.51 0.21 1.51 0.9 1.51 1.24 1.29 1.65 1.36 2.12 1.98 2.46 1.95 3.28 2.29 3.81 2.39 4.56 2.33 5.31 2.23 5.93 2.08 6.5 1.86 6.84 1.92 7.22 2.17 7.53 2.2 7.78 1.67 9.12 0.98 10.34 0.23 11.72 0.29 11.91 0.64 12.38 0.64 13.13 1.42 13.69 2.33 14.41 2.45 14.94 3.92 16.5 4.08 17.19 4.36 17.97 4.23 18.69 4.11 18.97 4.14 20.22 4.95 22.1 4.55 22.85 6.27 24.51 7.52 25.88 8.95 27.01 9.05 27.66 9.42 28.13 9.55 28.76 9.21 29.48 9.36 29.98 9.99 29.7 11.11 30.48 11.99 31.1 12.58 31.57 12.46 31.48',
  },
  {
    number: 2,
    name: 'Sacramento Drainage',
    type: 'path',
    value: 'M27,22.32,26.59,21l.16-1.72.62-1.78.5-1.59-.69-1.57-.93-.21L25.09,13l-1.47-.41-1.72-1-.28-.4-.13-.5.66-1,.53-.32,1.91-1.19,1.72-1.06L27,5.28V4l-.19-1,.12-1.51V.28H24.12V2.34L22.59,4.12,20,5.59h-.88L17.4,4.81l-.75-.6-3.88,1.1-.22.62.38.54-.63.59.09.59-.53.25.13.5-.32.29-.09.53-.56.84.28.81L9.39,12.06l-.4.72.46.66-.06.44.41,1.5-.19.78.34,1v1.59H9.17l-.28.32.06.47.6,1.06-.78.69-.1.62.32.44.43.09.22.5.5.41.44.34.47.44.37.69,1.16.44.75.44L14.74,28l.22.28,1.15,1h0l1.32.19.87-.66.92-.56.83-1.87,1.13-1,.56-.31,2.53-.74,1.43-.26,1.57.13.76.19Z',
  },
  {
    number: 3,
    name: 'Northeast Interior Basins',
    type: 'polygon',
    value: '28.4 22.22 28.59 0.28 26.93 0.28 26.93 1.5 26.81 3 27 4.03 27 5.28 26.31 7.09 24.59 8.15 22.68 9.34 22.15 9.65 21.49 10.66 21.62 11.16 21.9 11.56 23.62 12.59 25.09 13 26.25 14.1 27.18 14.31 27.87 15.88 27.37 17.47 26.75 19.25 26.59 20.97 26.96 22.32 28.06 24.44 28.46 25.04 28.96 25.91 30.12 26.7 30.75 27.41 31.09 28.29 33.06 29.57 32.97 30.04 33.62 30.73 33.34 31.57 33.72 31.86 34.19 31.61 35.09 31.35 36.22 31.51 37.85 29.94 28.4 22.22',
  },
  {
    number: 4,
    name: 'Central Coast Drainage',
    type: 'polygon',
    value: '28.2 51.16 27.56 48.61 27.46 46.49 26.96 46.08 26.9 45.55 24.56 43.8 24.49 43.2 24.24 42.58 23.68 42.27 23.21 41.2 21.99 40.05 22.68 39.17 20.77 37.98 20.77 36.3 19.55 35.95 19.46 35.29 19.62 34.92 19.12 33.7 17.74 32.2 17.58 31.48 16.3 30.85 16.02 30.1 16.11 29.25 14.82 29.5 13.68 29.28 13.33 29.71 13.25 30.56 13.54 31.27 12.46 31.48 12.58 31.57 12.49 32.7 12.52 33.36 13.11 33.98 13.21 34.83 13.55 36.26 13.68 36.73 15.14 37.55 16.3 37.48 17.02 37.98 17.02 39.8 16.24 40.11 16.15 40.98 16.58 42.58 17.83 43.42 18.4 44.24 18.59 44.52 18.93 44.67 19.27 45.55 20.02 46.14 20.05 46.92 21.15 47.43 21.96 48.46 22.96 48.9 22.74 49.8 23.43 50.93 24.46 50.93 24.62 52.02 24.58 52.13 25.37 51.62 25.87 51.9 26.09 51.52 25.62 50.96 25.87 50.68 27 51.15 28.21 51.21 28.2 51.16 28.2 51.16',
  },
  {
    number: 5,
    name: 'San Joaquin Drainage',
    type: 'path',
    value: 'M36.78,52.79l.5-.67,2.19-3.26,1.31-2.34.66-.47.06-.81-.59-1.85-.28-1.25-1.07-1.78-.62-1.69-.06-.84-.28-.75L37.13,36l-.79-1.59.19-.32-.28-.34-.59-.06-1.51-2-.43.22-.38-.28.28-.84L33,30l.09-.47-2-1.28-.34-.88-.63-.71L29,25.91,28.46,25l-.4-.6,0,0-.76-.19-1.57-.13-1.43.26-2.53.74-.56.31-1.13,1-.83,1.87-.92.56-.87.66-1.32-.19L16,30.1l.28.75,1.28.63.16.72,1.38,1.5.5,1.22-.16.37.09.66,1.22.34V38l1.91,1.19-.69.88,1.22,1.15.47,1.07.56.31.25.62.07.6,2.34,1.75.06.53.5.41.1,2.12.64,2.55.36.3.87.53,1.47.31.6.57.9.06.6.25.81.34,1.38.25.59-.06.69-.53.31-.41',
  },
  {
    number: 6,
    name: 'South Coast Drainage',
    type: 'path',
    value: 'M51.7,68.19l-.38-1.07-.59-1.06v-.78l-.63-1.69v-1l-3.47-3.34s-.25-.69-.34-.69-1.75-1.13-1.75-1.13l-1,0-.56-.4L42.13,57,42,56.46l-.68-.87-1.07-.79L39,54.09l-1-.35-.81.16-.38,0,0-1.16-.31.41-.69.53-.59.06-1.38-.25L33,53.18l-.6-.25-.9-.06-.6-.57L29.43,52l-.87-.53-.36-.3v.05L27,51.15l-1.13-.47-.25.28.47.56-.22.38-.5-.28-.79.51,0-.11-.22.56.28.69-.06.78.12.5-.21.82.62.09.5.72,2-.16,1.13.41h2.56l1.25.56,1,1.38,2.66.81H38l.72.85-.15,1.34,1.18.41.75-.32L42.79,63l1.68,1.37,1.19,1.53.63,3.32.78.94,4.78-.34v-1Z',
  },
  {
    number: 7,
    name: 'Southeast Desert Basins',
    type: 'path',
    value: 'M66.08,57.31l-1.6-1.41-.65-1.63-1-1.34.21-.78L44.76,35.58l-5.54-4.52-1.37-1.12-1.63,1.57-1.13-.16-.9.25,0,0,1.51,2,.59.06.28.34-.19.32L37.13,36l1.47,1.13.28.75.06.84.62,1.69,1.07,1.78.28,1.25.59,1.85-.06.81-.66.47-1.31,2.34-2.19,3.26-.5.67,0,1.14.38,0,.81-.16,1,.35,1.25.71,1.07.79.68.87.13.56.81.07.56.4,1,0s1.65,1.13,1.75,1.13.34.69.34.69l3.47,3.34v1l.63,1.69v.78l.59,1.06.38,1.07.15.62v1l-.32,0L63.45,69l.47-1.72-.47-.56-1,0V65l-.31-.53.13-.6,1.37-1.59,0-2.28.5-1.22Z',
  },
];

class Divisions extends Component {
  render() {
    this.width = this.props.width;
    this.height = this.props.height;

    const scale = this.props.width / 70;
    const labels = data.map(d => {
      return (
        <li key={d.name} style={{
          opacity: this.props.data[d.number] ? 1.0 : 0.25,
          fontWeight: this.props.data[d.number] ? 700 : null,
        }} onClick={() => {
          if (this.props.click) {
            this.props.click(d.number);
          }
        }}>
          <div className='dot' style={{
            background: this.props.color(d.number),
          }}>
            &nbsp;
          </div>
          <div className='label'>
            {d.name}
          </div>
        </li>
        );
    });
    const divisions = data.map(d => {
      let division;
      const id = `${d.id}-${d.name.replace(/ /g,'-')}`;
      let fill = this.props.color(d.number)
      let stroke = '#fff';
      if (this.props.title) {
        fill = '#49361e';
        stroke = '#1d1d1b'
      }
      const style = {
          fill,
          stroke,
          strokeMiterlimit: 10,
          strokeWidth: '0.25px',
          cursor: this.props.title ? null : 'pointer',
          opacity: this.props.title || this.props.data[d.number] ? 1.0 : 0.25,
        };
      if (d.type === 'path') {
        division = (
            <path key={id} id={id} d={d.value} style={style} onClick={() => {
              if (this.props.click) {
                this.props.click(d.number);
              }
            }} />
          );
      } else {
        division = (
            <polygon key={id} id={id} points={d.value} style={style} onClick={() => {
              this.props.click(d.number);
            }} />
          );
      }
      return division;
    });
    const labelContainer = (
      <div className='labels'>
        <ul>
          {labels}
        </ul>
        <div style={{padding: '1em 2.6em', fontWeight: 200, fontSize: '10px'}}>
          Click on a region to select/deselect.
        </div>
      </div>
    )
    const mapLabel = this.props.title ? null :
      (
        <text
          style={{fontWeight: 700, fontStyle: 'italic', fontSize: '14px', letterSpacing: '0.1em', textTransform: 'uppercase' }}
          y={this.props.height}
        >
          Region
        </text>
      );

    return (
      <div>
        <svg width={`${this.width}px`} height={`${this.height}px`} >
          <g id='divisions' transform={`scale(${scale})`}>
            {divisions}
          </g>
          {mapLabel}
        </svg>
        {this.props.title ? null : labelContainer}
      </div>
    );
  }
}

Divisions.defaultProps = {
  title: false,
}
export default Divisions;



// WEBPACK FOOTER //
// ./src/Divisions.js